angular.module('galilai.creator').controller('ContentController', function($scope, experiments, $timeout, $rootScope, api) {
    let publishModal = null
    let plansModal = null
    let updatePaymentModal = null

    const DEFAULT_CONTEXT_TYPE = 'personalized'
    const LOADING_IMAGE = 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif'
    const SHOULD_MERGE_TITLE_IMAGES = true
    $scope.config = {
        items: []
    },
    $scope.post = null

    $scope.view = {
        state: {
            lastPostSaved: null,
            processingDownload: false,
            downloadUrl: null,
            downloadImages: [],
            generateInput : true,
            generatingContent: false
        },
    }
    $rootScope.tab = 'editor'
    $rootScope.mode = 'calendar'
    $rootScope.isLoadingPost = false
    $scope.currentReader = null

    $rootScope.$on('onUserData', function(event, args) {
        $rootScope.setFeatures(args.features)
        if (args.features && args.features.import_templates) {
            $scope.view.state.importTemplates = true
        }
        if (args.features && args.features.dynamic_templates) {
            $scope.view.state.dynamicTemplates = true
        }
    })

    $rootScope.$on('getCurrentPost', function(event, data) {
        $rootScope.$broadcast('currentPost', {
            post: $scope.post,
            data: data,
        })
    })

    $rootScope.$on('media.selected', function(event, medias, source) {
        if (source == 'select-main-audio') {
            if (!$scope.post.data.timeline) {
                $scope.post.data.timeline = {}
            }
            if (!$scope.post.data.timeline.main) {
                $scope.post.data.timeline.main = {}
            }
            $scope.post.data.timeline.main.audio = {
                url: medias[0].url,
            }

            $rootScope.$emit('changeTimeline', {
                timeline: $scope.post.data.timeline
            })
            savePost()
        }
    })

    function savePost() {
        $rootScope.$broadcast('getPost', {
            type: 'sync'
        })
    }

    $rootScope.showAllPostsURL = window.location.origin + window.location.pathname
    $rootScope.isEditor = function() {
        return $rootScope.mode === 'editor'
    }
    $rootScope.isCalendar = function() {
        return $rootScope.mode === 'calendar'
    }
    $rootScope.loading = {
        design: false,
        create: false,
    }
    $rootScope.userConfig = {}

    $rootScope.isLoadingDesign = function() {
        return $rootScope.loading.design
    }
    $rootScope.loadingDesign = function() {
        $rootScope.loading.design = true
    }
    $rootScope.loadedDesign = function() {
        $rootScope.loading.design = false
    }
    $rootScope.isLoadingCreate = function() {
        return $rootScope.loading.create
    }
    $rootScope.loadingCreate = function() {
        $rootScope.loading.create = true
    }
    $rootScope.loadedCreate = function() {
        $rootScope.loading.create = false
    }

    // Listen to message
    window.addEventListener('message', function(event) {
        if (event.data && event.data.name == 'stopAndClean') {
            $timeout(function() {
                $scope.stopAndClean()
            })
        }

        if (event.data && event.data == 'schedulePost') {
            $timeout(() => {
                $scope.showPublish('publish', 'bulkSchedule')
            })
        }
    })

    $rootScope.showTrial = function(source) {
        window._LOGIN_SOURCE = 'trial'
        let params = {}
        if (source) {
            params.source = source
        }
        track('Editor Trial Show', params)

        if (experiments.isVariant('show-plans-instead-trial') || isLoggedIn() || $rootScope.IAPEnabled()) {
            $rootScope.showUpgrade(source, {
                track: false
            })
            return
        }
        $rootScope.trialMode = 'initial'
        trialModal.modal('show')
        $rootScope.$emit('trialSource', source)
    }

    $rootScope.showTrialExpired = function(source) {
        let params = {}
        if (source) {
            params.source = source
        }
        track('Editor Trial Expired Show', params)
        $rootScope.showUpgrade(source, {
            track: false
        })
    }

    $rootScope.showTrialOrExpired = function(source) {
        let isTrialExpired = false
        if ($rootScope.userConfig && $rootScope.userConfig.billing && $rootScope.userConfig.billing.expired) {
            isTrialExpired = true
        }
        if (isTrialExpired) {
            $rootScope.showTrialExpired(source)
        } else {
            $rootScope.showTrial(source)
        }
    }

    $rootScope.showUpgrade = function(source, extras) {
        window._LOGIN_SOURCE = 'upgrade'
        plansModal.modal('show')
        if (source) {
            $rootScope.$emit('plansSource', source)
        }
        let params = {}
        if (source) {
            params.source = source
        }
        if (extras && typeof extras.track === 'boolean' && !extras.track) {
            return
        }

        if ($rootScope.hasSomeActivePlan()) {
            // Upgrade Plans Event
            track('Editor Plans Upgrade Show', params)
        } else {
            track('Editor Trial Show', params)
        }
    }

    $rootScope.hideUpgrade = function() {
        if (!plansModal.hasClass('show')) {
            return
        }
        plansModal.modal('hide')
        track('Editor Plans Upgrade Hide')
    }

    $rootScope.hideTrial = function() {
        if (!trialModal.hasClass('show')) {
            return
        }
        trialModal.modal('hide')
        track('Editor Trial Hide')
    }

    $rootScope.hasSomeActivePlan = function() {
        if (!$rootScope.userConfig || !$rootScope.userConfig.billing || !$rootScope.userConfig.billing.customer || !$rootScope.userConfig.billing.plan) {
            return false
        }
        return [_PLANS.BASIC, _PLANS.PLUS, _PLANS.PRO, _PLANS.MAX, _PLANS.SHOP, _PLANS.ADS, _PLANS.INFINITE].includes($rootScope.userConfig.billing.plan.id)
    }

    $rootScope.isProCustomer = function() {
        if (!$rootScope.userConfig || !$rootScope.userConfig.billing || !$rootScope.userConfig.billing.customer || !$rootScope.userConfig.billing.plan) {
            return false
        }
        return [_PLANS.PLUS, _PLANS.PRO, _PLANS.MAX, _PLANS.SHOP, _PLANS.ADS, _PLANS.INFINITE].includes($rootScope.userConfig.billing.plan.id)
    }

    $rootScope.isPremiumCustomer = function() {
        if (!$rootScope.userConfig || !$rootScope.userConfig.billing || !$rootScope.userConfig.billing.customer || !$rootScope.userConfig.billing.plan) {
            return false
        }
        return [_PLANS.PRO, _PLANS.MAX, _PLANS.SHOP, _PLANS.ADS, _PLANS.INFINITE].includes($rootScope.userConfig.billing.plan.id)
    }

    $rootScope.isMaxCustomer = function() {
        if (!$rootScope.userConfig || !$rootScope.userConfig.billing || !$rootScope.userConfig.billing.customer || !$rootScope.userConfig.billing.plan) {
            return false
        }
        return [_PLANS.MAX, _PLANS.SHOP, _PLANS.ADS, _PLANS.INFINITE].includes($rootScope.userConfig.billing.plan.id)
    }


    $rootScope.getTotalSocialAccounts = function() {
        if (!$rootScope.userConfig || !$rootScope.userConfig.billing || !$rootScope.userConfig.billing.customer || !$rootScope.userConfig.billing.plan) {
            return 1
        }
        if ($rootScope.userConfig.billing.plan.id == _PLANS.INFINITE) {
            return Infinity
        }
        return $rootScope.userConfig.billing.plan.quantity || 1
    }

    $rootScope.isCustomer = function(showModal=true, source='') {
        let isCustomer = false
        let isTrialExpired = false
        if ($rootScope.userConfig && $rootScope.userConfig.billing && $rootScope.userConfig.billing.customer) {
            isCustomer = true
        }
        if ($rootScope.userConfig && $rootScope.userConfig.billing && $rootScope.userConfig.billing.expired) {
            isTrialExpired = true
        }
        if (!isCustomer && showModal) {
            if (isTrialExpired) {
                $rootScope.showTrialExpired(source)
            } else {
                $rootScope.showTrial(source)
            }
        }
        return isCustomer
    }

    $rootScope.$on('doAction', function(event, data) {
        $scope.doAction(data)
    })

    $scope.userPrompt = ''
    $scope.generateResult = ''

    $scope.parseText = function (text) {
        let highlightColor = '#HIGHLIGHT'
        let textOnHighlightColor = '#BWHIGHLIGHT'

        let currentNumberOfItems = 0
        if ($scope.config.items && $scope.config.items.length) {
            currentNumberOfItems = $scope.config.items.length
        }

        $scope.currentText = text
        text = text.replaceAll('![]\\(','\n')
        // Fix title list item
        text = text.replace(/\\./mg, '.')
        //let posts = text.split('\n\n  \n\n  \n\n')

        // Add two new lines after first line
        //text = text.replace(/^(.*)$/mg, '$1\n\n')

        function postsSplitter(text) {
            let lines = text.split('\n\n')
            let posts = []
            let currentText = ''

            for (var i=0; i < lines.length; i++) {

                let line = lines[i]
                let nextLine = i < lines.length - 1 ? lines[i+1] : null
                // Add new post if next line is a list item (start with number (regex) or -) or empty new line
                let isListItem = !!(nextLine && (nextLine.startsWith('-') || nextLine.match(/^\d+\./)))
                let isNewLine = nextLine && nextLine.trim() == ''
                if (isListItem || isNewLine) {
                    currentText += line + '\n\n'
                    if (currentText !== '') {
                        posts.push(currentText)
                        currentText = ''
                    }
                } else {
                    currentText += line + '\n\n'
                }
            }
            if (currentText.trim() !== '') {
                posts.push(currentText)
            }
            posts = posts.map(function(item) {
                item = item.trim()
                return item
            })
            return posts
        }
        let posts = postsSplitter(text)
        $scope.config.items = []

        function processImages(images) {
            // If is url, call via /api/forward
            // ELse don't do anything
            return images.map((image) => {
                if (image.startsWith('http')) {
                    return `/api/forward?url=${encodeURIComponent(image)}`
                }
                return image
            })
        }

        function improveTitle(title) {
            return title
        }


        function fixBoldNumbers(text) {
            // May have or not punctuation
            if (!text.match(/^\*\*\d+[\.\)\:\-]?\s/)) {
                return text
            }
            let parts = text.split(' ')
            let number = parts[0]
            let restOfText = parts.slice(1).join(' ')
            return `${number}** **${restOfText}`
        }
        function highlighText(text, color, type) {
            text = fixBoldNumbers(text)
            // Match bold
            let isNumber = false
            let regex = /\*\*(.*?)\*\*/g
            let regexPunctuation = /^(\d+[\.\)\:\-]?\s?)(.*)$/;
            let match;
            let number = null

            while (match = regex.exec(text)) {
                let replacement = match[1]
                isNumber = !!replacement.match(/^\d+$/)
                let className = ''

                let isNumberWithPunctuation = !!replacement.match(regexPunctuation)
                if (isNumberWithPunctuation) {
                    number = replacement.match(regexPunctuation)[1]
                    // Get only numbers
                    number = number.replace(/[^0-9]/g, '')
                    className = ' class="number-highlight"'
                }
                if (isNumber && type === 'title') {
                    replacement = `<em style="font-size:6rem;display:block;font-weight:bold;font-style:normal;line-height:normal;color:${color}"${className}>${replacement}</em>`
                } else {
                    replacement = `<em style="font-style:normal;font-weight:bold;color:${color}"${className}>${replacement}</em>`
                }
                text = text.replace(match[0], replacement)
            }

            // Match underline
            function replaceUnderline(text) {
                // ++
                let regex = /\+\+(.*?)\+\+/g
                let match;
                while (match = regex.exec(text)) {
                    let replacement = match[1]
                    let replacementText = `<u style="text-decoration-color:${color}">${replacement}</u>`
                    text = text.replace(match[0], replacementText)
                }
                return text
            }

            // Match strike
            function replaceStrike(text) {
                // ~~
                let regex = /~~(.*?)~~/g
                let match;
                while (match = regex.exec(text)) {
                    let replacement = match[1]
                    let replacementText = `<s style="text-decoration: none; background:${color}; color: ${textOnHighlightColor}">${replacement}</s>`
                    text = text.replace(match[0], replacementText)
                }
                return text
            }
            // Match italic
            function replaceItalic(text) {
                // _
                let regex = /_(.*?)_/g
                let match;
                while (match = regex.exec(text)) {
                    let replacement = match[1]
                    let replacementText = `<i style="font-style: normal;text-decoration-line: underline; text-decoration-style: wavy; text-decoration-skip-ink: none;text-decoration-color:${color}">${replacement}</i>`
                    text = text.replace(match[0], replacementText)
                }
                return text
            }

            text = replaceUnderline(text)
            text = replaceStrike(text)
            text = replaceItalic(text)
            // TODO - maybe should use current theme
            text = applyDynamicStyles(text, $scope?.post?.data?.theme)

            return {
                text: text,
                number: number
            }
        }

        function highlightNumbersAtBeginning(text, color) {
            // Match numbers at the beginning of the line and highlight them
            const regex = /^(\d+[\.\)\:\-]?\s)(.*)$/;
            return text.replace(regex, `<em style="font-style:normal;font-weight:bold;color:${color}">$1</em> $2`);
        }

        for (let i = 0; i < posts.length; i++) {
            let post = posts[i]
            // Extract all markdown image urls ![](url)
            let images = []
            let imageRegex = /!\[(.*?)\]\((.*?)\)/g;
            let match;
            while (match = imageRegex.exec(post)) {
                images.push(match[2])
            }
            // Remove all markdown image urls (using regex)
            post = post.replace(/!\[(.*?)\]\((.*?)\)/g, '')

            function parseTitleAndDescription(post) {
                let additionalValues = {}
                for (let attr in specialAttributes) {
                    let attrRegex = new RegExp(`^${specialAttributes[attr]}(.*)$`, 'gm')
                    while (match = attrRegex.exec(post)) {
                        additionalValues[attr] = match[1]
                        post = post.replace(match[0], '')
                        break
                    }
                }

                // Lines with numbers
                if (post.startsWith('->')) {
                    return {
                        title: '',
                        description: post.replace(/->/g, '').split('\n').map(function(item) {
                            let replacement = highlightNumbersAtBeginning(item, highlightColor)
                            return replacement
                        }).join('\n')
                    }
                }
                // Splits title into title and description
                post = post.replace(/(\d+[\.\-].*?)\s?(-|:)\s/g, '$1\n')
                let title = post.split('\n')[0]

                //let description = post.split('\n').slice(1).join('\n')
                // LATER - Review
                let description = post.split('\n').slice(1).filter(item => item.trim() !== '').join('\n')
                let parsedContent = {
                    title: title,
                    description: description,
                }
                for (let attr in additionalValues) {
                    parsedContent[attr] = additionalValues[attr]?.trim()
                }
                return parsedContent
            }

            let content = parseTitleAndDescription(post)
            let title = content.title
            let description = content.description

            if (!title.trim() && !description.trim()) {
                continue
            }
            let highlightedText = highlighText(improveTitle(title), highlightColor, 'title')
            let highlightedDescription = highlighText(description, highlightColor, 'description')
            let itemPost = {
                title: highlightedText.text,
                number: highlightedText.number || highlightedDescription.number,
                descriptions: [highlightedDescription.text],
                images: processImages(images)
            }

            for (let attr in specialAttributes) {
                if (content[attr]) {
                    itemPost[attr] = content[attr]
                }
            }

            $scope.config.items.push(itemPost)
        }
        $rootScope.$broadcast('contentChanged', $scope.config)
        if ($scope.config.items.length > currentNumberOfItems) {
            $rootScope.$broadcast('onItemCreated', $scope.config.items)
        }
    }

    $scope.saveAll = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Save Post')) {
            return
        }
        $rootScope.$broadcast('getPost', {
            type: 'save'
        })

        track('Editor Save', {
            postId: $rootScope.postId
        })
    }

    $scope.previewPost = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Preview Post')) {
            return
        }
        $rootScope.$broadcast('getPost', {
            type: 'preview'
        })
        track('Editor Preview', {
            postId: $rootScope.postId
        })
    }

    $scope.showPreview = function(data) {
        if (!$rootScope.isPremiumCustomer() && data.post.format == 'reels') {
            $rootScope.showUpgrade('Publish Reels')
            return
        }
        let postId = $rootScope.postId
        if (!data.post) {
            return
        }
        api.savePost(postId, data.post)
        .then(function(res) {
            let url = window.location.href.split('/').slice(0, -1).join('/')
            window.open(url + '/preview/?id=' + postId+'&edit=true', '_blank')
        }).catch(function(err) {
            showError(gettext('error.rendering_post'))
        })
    }

    $scope.downloadAll = function() {
        if (!$rootScope.isCustomer(showModal = true, source='Download Post')) {
            return
        }
        $rootScope.$broadcast('getPost', {
            type: 'download'
        })
        track('Editor Download', {
            postId: $rootScope.postId
        })
    }

    $scope.render = function() {
        $scope.parseText($scope.currentText);
    }

    $scope.toggleGenerateView = function() {
        $scope.view.state.generateInput = !$scope.view.state.generateInput
    }

    $scope.stopGenerating = function() {
        console.log('Stopping generating')
        if (!$scope.currentReader) {
            return
        }
        $scope.currentReader.cancel()
        $scope.currentReader = null
    }

    $scope.stopAndClean = function() {
        $scope.stopGenerating()
        setEditorText($scope.post.data.text.split('\n')[0]+'\n\n')
        $timeout(function() {
            $scope.render()
        })
    }

    $scope.clearText = function() {
        showConfirm(gettext('label.are_you_sure'), null, function(status) {
            if (status) {
                setEditorText('')
                $timeout(function() {
                    $scope.render()
                })
            }
        })
    }

    $scope.startCreating = function() {
        $scope.view.state.generateInput = false
        $scope.userPrompt = ''
        $rootScope.started = true;
    }

    $scope.generate = function(userPrompt) {
        checkLogin(function() {
            if (!userPrompt || !userPrompt.trim()) {
                return
            }
            let firstUse = !$rootScope.started
            $rootScope.started = true;

            let input = {
                form: 'creator',
                parser: 'creator',
                inputs: {
                    context: userPrompt
                }
            }

            let text = ''
            $scope.generateResult = ''
            $scope.loading = true
            if (firstUse) {
                $scope.toggleGenerateView();
                $rootScope.tab = 'design'
            }
            generateStream(input, function(err, response, done, reader) {
                $scope.currentReader = reader;

                if (err) {
                    showError(gettext('error.generating.content'))
                    $timeout(() => {
                        $scope.loading = false
                    })
                    return
                }
                if (done) {
                    $timeout(() => {
                        $scope.loading = false
                    })
                    return
                }
                text += response;
                let results = {
                    results: parseResults(text, 'single'),
                    continue: false,
                    replace: {},
                }
                if (firstUse) {
                    getEditor(function(editor) {
                        editor.setText(results.results[0].text)
                    })
                } else {
                    $timeout(function(){
                        $scope.generateResult = results.results[0].text
                    })
                }
            })
        })
    }

    function setEditorText(text, cb) {
        // Apply formats
        getEditor(function(editor){
            const patterns = [
                {
                    regex: /<b>([^<]+)<\/b>/g,
                    format: 'bold',
                    tag: '<b></b>'
                },
                {
                    regex: /<i>([^<]+)<\/i>/g,
                    format: 'italic',
                    tag: '<i></i>'
                },
                {
                    regex: /<u>([^<]+)<\/u>/g,
                    format: 'underline',
                    tag: '<u></u>'
                },
                {
                    regex: /<s>([^<]+)<\/s>/g,
                    format: 'strike',
                    tag: '<s></s>'
                },
                {
                    regex: /<l>([^<]+)<\/l>/g,
                    format: 'large',
                    tag: '<l></l>'
                },
                {
                    regex: /<z\d+>([^<]+)<\/z\d+>/g,
                    format: '',
                    tag: '<z0000000></z0000000>',
                }
            ]
            let mapKeep = {
                '<br>': '',
                '<br/>': ''
            }
            // Replace all
            for (let key in mapKeep) {
                text = text.replace(new RegExp(key, 'g'), mapKeep[key])
            }

            let unifiedPattern = /<b>([^<]+)<\/b>|<i>([^<]+)<\/i>|<u>([^<]+)<\/u>|<s>([^<]+)<\/s>|<l>([^<]+)<\/l>|<z\d+>([^<]+)<\/z\d+>/g

            const matches = text.match(unifiedPattern);

            let ranges = []
            // Calculate the start and end indices of the unformatted text
            let startIndex = 0;
            if (!matches) {
                editor.setText(text)
                return
            }
            for (const match of matches) {
                const index = text.indexOf(match, startIndex);
                const endIndex = index + match.length;
                if (match.startsWith('<z')) {
                    const fullTagMatch = match.match(/<(?<tag>z\d+)>.*?<\/\k<tag>>/);
                    if (fullTagMatch?.groups?.tag) {
                        let fullTag = fullTagMatch.groups.tag;
                        const pattern = {
                            format: fullTag,
                            tag: `<${fullTag}></${fullTag}>`
                        };
                        ranges.push({ start: index, end: endIndex, pattern: pattern });
                    }
                } else {
                    let pattern = patterns.find((pattern) => {
                        return match.match(pattern.regex)
                    })
                    if (!pattern) {
                        continue
                    }
                    ranges.push({ start: index, end: endIndex, pattern: pattern });
                }

                startIndex = endIndex;
            }

            let diff = 0
            let index = 0
            for (let range of ranges) {
                if (index++ > 0) {
                    range.start -= diff
                }
                diff += range.pattern.tag.length
                range.end -= diff
            }
            let unformattedText = text.replace(/<[^>]+>/g, '');
            editor.setText(unformattedText)

            for (let range of ranges) {
                editor.formatText(range.start, range.end - range.start, range.pattern.format, true)
            }

            $timeout(function() {
                if (cb) {
                    cb()
                }
            })
        })
    }

    $scope.loadPost = function(post) {
        let params = new URLSearchParams(window.location.search)
        function getParameterByName(name) {
            return params.get(name)
        }
        if (post && post.data && !post.data.format) {
            post.data.format = getParameterByName('ptype') || 'post'
            if (post.data.format == 'story' || post.data.format == 'reels') {
                if (!post.data.theme) {
                    post.data.theme = {}
                }
                post.data.theme.size = {
                    width: 1,
                    height: 1.777777777778
                }
            }
        }
        $rootScope.$broadcast('loadPost', post.data, post)
        $scope.post = post
        // TODO - Review this check for Reels
        //if (!$scope.isRendering()) {
            setEditorText(post.data.text, function() {
                $scope.afterLoadPost()
            })
        //}
        $scope.loadProject()
    }

    $scope.loadProject = function() {
        if (!$scope.post) {
            return
        }
        if (!$scope.post.meta || !$scope.post.meta.project) {
            return
        }
        let projectId = $scope.post.meta.project
        api.getProject(projectId).then(function(res) {
            $scope.post.project = res.data
        })
        .catch(function() {
            // TASK - No handling
        })
     }

    $scope.generatePostContent = function() {
        $rootScope.$broadcast('getPost', {
            type: 'generateInitialContent'
        })
    }

    $scope.generateInitialContent = function(post, force=false) {
        if (!isLoggedIn()) {
            return
        }
        let alreadyGenerated = post.data.generated || (post.meta && post.meta.edited)
        let isScratch = post.meta && post.meta.scratch

        // Get from search
        let firstPageOnly = false
        if (new URLSearchParams(window.location.search).get('firstPageOnly')) {
            firstPageOnly = true
        }
        if ((alreadyGenerated || isScratch || firstPageOnly) && !force) {
            console.log('Ignore generating content')
            return
        }
        $scope.view.state.generatingContent = true
        $rootScope.isGeneratingContent = true

        const type = force? 'force': 'initial'

        function onNewContent(response) {
            // Replace all _EOL_ with \n
            response = response.replace(/_EOL_/g, '\n')

            // TODO - Move to server fix
            response = response.replace(/"/g, '')
            response = response.replace(/\\n/g, '\n')

            // Replace triple new lines with double
            response = response.replace(/\n\n\n/g, '\n\n')

            // Insert line by line
            function insertLine(text) {
                let index = getEditor().getText().length
                let nextIndex = index
                getEditor().insertText(nextIndex, text);
                // Match initial numbers at each new line and bold them
                let matches = text.match(/^[0-9]+\. /g)
                if (matches) {
                    getEditor().formatText(nextIndex, matches[0].length, "bold", true);
                }
            }
            let lines = response.match(/(.*?\n|.+$)/g);
            for (let line of lines) {
                insertLine(line)
            }
        }
        let extras = {}
        if (post && post.meta && post.meta.contextType) {
            extras.contextType = post.meta.contextType
        }
        function generateData() {
            api.generateInitialStream($rootScope.postId, type, extras, {
                cbInit: function(reader) {
                    let text = getEditor().getText()
                    // Add new line to initial text if needed
                    if (text.length > 0 && text.split('\n').length <= 2) {
                        getEditor().insertText(text.length, '\n')
                    }
                    getEditor().disable();
                    $rootScope.loadingCreate()
                },
                cbProgress: function(err, response, done, reader) {
                    $scope.currentReader = reader
                    if (!response || err) {
                        return
                    }
                    try {
                        if (response.error) {
                            return
                        }
                    } catch (e) {}

                    onNewContent(response)
                },
                cbFinish: function(err, response, done, reader) {
                    $timeout(function() {
                        $scope.view.state.generatingContent = false
                        $rootScope.isGeneratingContent = false
                        getEditor().enable();
                        $rootScope.loadedCreate()
                    })
                    window.postMessage({
                        name: 'postContentFinished',
                    })
                },
                cbError: function(err, response, done, reader) {
                    $timeout(function() {
                        $scope.view.state.generatingContent = false
                        $rootScope.isGeneratingContent = false
                        console.log('Initial generation error', err)
                        getEditor().enable();
                        $rootScope.loadedCreate()
                    })
                    window.postMessage({
                        name: 'postContentFinished',
                    })
                }
            })
        }

        getEditor(generateData)
    }

    $scope.showImport = function() {
        let importModal = angular.element('#import-modal')
        importModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })

        $rootScope.$emit('openImport', {
            projectId: $scope.post.meta.project
        })
    }

    $scope.afterLoadPost = function() {
        $rootScope.tab = 'design'

        let isGenerated = $scope.post.data && $scope.post.data.generated
        let isEdited = $scope.post.meta && $scope.post.meta.edited
        let isScratch = $scope.post.meta && $scope.post.meta.scratch
        if ($scope.post && !$scope.post.meta) {
            $scope.post.meta = {}
        }
        if (!$scope.post.meta.contextType) {
            $scope.post.meta.contextType = DEFAULT_CONTEXT_TYPE
        }
        if ($scope.isRendering() || isScratch || isEdited || isGenerated) {
            return
        }
        // If reels, generate content
        if ($scope.post.data && $scope.post.data.format == 'reels') {
            $scope.generatePostContent()
            return
        }

        let contentModal = angular.element('#content-type-modal')
        // Prevent from closing
        contentModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })
        let alreadySelected = false
        $rootScope.$on('contentTypeChanged', function(event, data) {
            if (alreadySelected) {
                return
            }
            alreadySelected = true
            let type = data.value
            if (data.multiple) {
                $scope.generatePostContent()
            }
            let mapFormat = {
                'carousel': 'post',
                'reels': 'reels',
                'post': 'post',
                'story': 'story',
            }
            $scope.post.data.format = mapFormat[type]
            $rootScope.$emit('changeFormat', {
                format: mapFormat[type]
            })
            if (mapFormat[type] == 'story' || mapFormat[type] == 'reels') {
                $rootScope.$emit('changePostSize', {
                    size: 'story'
                })
            }
            if ($scope.shouldSave()) {
                $rootScope.$broadcast('getPost', {
                    type: 'sync'
                })
            }
            // Hide modal
            contentModal.modal('hide')
        })
    }

    $scope.initAuth = function() {
        function getUserConfig() {
            if (!isLoggedIn()) {
                return
            }
            api.config({}).then(function(res) {
                $rootScope.userConfig = res.data
                // TASK [LP] - Should hide trial?
                $rootScope.hideTrial()
                $rootScope.$emit('onUserData', $rootScope.userConfig)
                localStorage.setItem('auth.user.email', $rootScope.userConfig.user.email)
                if ($rootScope.userConfig.user && $rootScope.userConfig.user.name) {
                    localStorage.setItem('auth.user.name', $rootScope.userConfig.user.name)
                }
                localStorage.setItem('auth.user.id', $rootScope.userConfig.user.id)

                $rootScope.getIAPSubscription($rootScope.userConfig.user.id)

                try {
                    if ($rootScope.userConfig.user.area) {
                        safeSetStorage('auth.user.area', $rootScope.userConfig.user.area)
                    }
                    if ($rootScope.userConfig.billing.plan) {
                        if ($rootScope.userConfig.billing.plan.id) {
                            safeSetStorage('auth.user.billing.plan.id', $rootScope.userConfig.billing.plan.id)
                        }
                        if ($rootScope.userConfig.billing.plan.period) {
                            safeSetStorage('auth.user.billing.plan.period', $rootScope.userConfig.billing.plan.period)
                        }
                        if ($rootScope.userConfig.billing.plan.quantity) {
                            safeSetStorage('auth.user.billing.plan.quantity', $rootScope.userConfig.billing.plan.quantity)
                        }
                    }
                } catch (e) {
                    console.log('Error setting storage', e)
                }

                try {
                    let billingStatus = $rootScope.userConfig.billing.status
                    let validStatus = [
                        'trial',
                        'cancelled',
                        'active',
                    ]
                    if (safeGetStorage('auth.user.billing.status') != billingStatus) {
                        let data = {email: $rootScope.userConfig.user.email}
                        try {
                            if ($rootScope.userConfig.user.area) {
                                data.area = $rootScope.userConfig.user.area
                            }
                            if ($rootScope.userConfig.billing.plan) {
                                if ($rootScope.userConfig.billing.plan.id) {
                                    data.planId = $rootScope.userConfig.billing.plan.id
                                }
                                if ($rootScope.userConfig.billing.plan.period) {
                                    data.planPeriod = $rootScope.userConfig.billing.plan.period
                                }
                                if ($rootScope.userConfig.billing.plan.quantity) {
                                    data.planQty = $rootScope.userConfig.billing.plan.quantity
                                }
                            }
                        } catch (e) {}
                        if (validStatus.includes(billingStatus)) {
                            let eventName = billingStatus.charAt(0).toUpperCase() + billingStatus.slice(1)
                            identifyUserData(data, eventName)
                        } else {
                            identifyUserData(data)
                        }
                        safeSetStorage('auth.user.billing.status', billingStatus)
                    } else {
                        console.log('Billing status not changed', billingStatus)
                    }
                } catch (e) {}
            }).catch(function(err) {
                if (localStorage.getItem('auth.token')) {
                    localStorage.removeItem('auth.token')
                    reloadLocation()
                    logError({
                        message: 'Error loading user config',
                        error: err,
                    })
                }
            })
        }
        let interval = setInterval(() => {
            if (isLoggedIn()) {
                clearInterval(interval)
                getUserConfig();
            }
        }, 50)

        if (!isLoggedIn()) {
            return
        }
        clearInterval(interval)
        getUserConfig()
    }

    $scope.setupLeadInfo = function() {
        let params = new URLSearchParams(window.location.search)
        let instagram = params.get('instagram')
        let email = params.get('email')
        if (instagram) {
            localStorage.setItem('auth.user.instagram', instagram)
        }
        if (email) {
            localStorage.setItem('auth.user.email', email)
            // TASK [HP] - Create user
        }
    }

    $scope.showFeatures = function() {
        if (isLoggedIn()) {
            return
        }
        // Add display block to #header-creator, #cards-creator
        let header = document.getElementById('header-creator')
        let cards = document.getElementById('cards-creator')
        if (!header || !cards) {
            return
        }
        header.style.display = 'block'
        cards.style.display = 'block'

        // On click any link inside cards, scroll up and focus on input #social-handle
        let links = cards.getElementsByTagName('a')
        for (let link of links) {
            link.addEventListener('click', function(e) {
                e.preventDefault()
                window.scrollTo(0, 0)
                let input = document.getElementById('social-handle')
                if (input) {
                    input.focus()
                }
            })
        }
        // Make all [data-ref="landing-items"] visible
        let landingItems = document.querySelectorAll('[data-ref="landing-items"]')
        for (let item of landingItems) {
            item.style.display = 'block'
        }
    }


    let downloadTimer = null
    $scope.showDownload = function(data) {
        if (!$rootScope.isPremiumCustomer() && ($scope.post.data.format == 'reels' || $scope.post.data.mediaFormat == 'video')) {
            $rootScope.showUpgrade('Publish Reels')
            return
        }
        let postId = $rootScope.postId
        $scope.view.state.processingDownload = true
        $scope.view.state.downloadUrl = null
        $scope.view.state.downloadImages = []
        $scope.view.state.downloadProgress = 0;
        let downloadModal = angular.element('#download-modal')
        downloadModal.modal('show', {
            backdrop: 'static',
            keyboard: false
        })

        let numberItems = $scope.post.data.items.length
        let durationPerItem = 3
        let baseDuration = 5
        if ($scope.post.data.format == 'reels' || $scope.post.data.mediaFormat == 'video') {
            durationPerItem = 15
            baseDuration = 45
        }
        let totalDuration = numberItems * durationPerItem + baseDuration
        downloadTimer = setInterval(() => {
            $timeout(() => {
                $scope.view.state.downloadProgress += 100 / (totalDuration)
                if ($scope.view.state.downloadProgress > 100) {
                    $scope.view.state.downloadProgress = 100
                }
            })
        }, 1000)
        if (!$scope.shouldSave()) {
            return
        }

        function clearProgress() {
            $timeout(function() {
                $scope.view.state.processingDownload = false
            })
            if (downloadTimer) {
                clearInterval(downloadTimer)
            }
        }

        function clear() {
            clearInterval(intervalMonitoring)
            clearProgress()
            downloadModal.modal('hide')
        }

        let intervalMonitoring = null
        function monitorRender(renderId) {
            intervalMonitoring = setInterval(() => {
                api.monitorRenderStatus(renderId).then(function(res) {
                    console.log('Monitor render', res.data)
                    if (res.data.status != 'pending') {
                        clearInterval(intervalMonitoring)
                        clearProgress()
                        if (res.data.url) {
                            $timeout(function() {
                                $scope.view.state.downloadUrl = res.data.url
                                $scope.view.state.downloadImages = res.data.images
                                $scope.notifyPostSaved()
                            })
                        } else {
                            // TODO
                            showError(gettext('error.rendering_post'))
                            clear()
                        }
                    }
                })
                .catch(function(err) {
                    clear()
                })
            }, 5000)
        }
        api.savePost(postId, data.post).then(function(res) {
            return api.scheduleRenderPost(postId)
        })
        .then(function(res) {
            let renderId = res.data.id
            if (!renderId) {
                throw new Error('Error rendering post')
            }
            monitorRender(renderId)
        }).catch(function(err) {
            showError(gettext('error.rendering_post'))
            clear()
        })
    }

    function fixTheme(current) {
        let baseTheme = {
            size: {
                width: 1,
                height: 1.25
            },
            fonts: {
                primary: 'Syne',
                secondary: 'Noto Sans',
            },
        }
        let updated = Object.assign(baseTheme, current)
        return updated
    }

    $scope.enableEmbed = function() {
        $rootScope.embed = true
        // Find body > .navbar and hide it
        let navbar = document.querySelector('body > .navbar')
        if (navbar) {
            navbar.style.display = 'none'
        }
        // Hide #header-creator-top
        let header = document.getElementById('header-creator-top')
        if (header) {
            header.style.display = 'none'
        }

        // Find .footer
        let footer = document.querySelector('.footer')
        if (footer) {
            footer.style.display = 'none'
        }

    }

    $scope.shouldSave = function() {
        let render = new URLSearchParams(window.location.search).get('renderKind')
        if (!render) {
            return true
        }
        return false
    }

    $scope.isRendering = function() {
        let render = new URLSearchParams(window.location.search).get('renderKind')
        if (render) {
            return true
        }
        return false
    }

    $scope.initModes = function() {
        $scope.initAuth()
        $scope.setupLeadInfo()

        let id = new URLSearchParams(window.location.search).get('id')
        // get #config from hash
        let configParams = null
        try {
            configParams = new URLSearchParams(window.location.hash.substr(3)).get('config')
        } catch (e) {}

        // Check if url has embed param
        try {
            let embed = new URLSearchParams(window.location.search).get('embed')
            if (embed) {
                $scope.enableEmbed()
            }
        } catch (e) {}

        if (id) {
            $rootScope.isLoadingPost = true
            track('Editor Single View', {
                postId: id
            })
            $rootScope.mode = 'editor'
            $rootScope.tab = 'design'
            $rootScope.postId = id
            $scope.startCreating()
            _dstart('fetch post')
            api.getPost(id).then(function(res) {
                _dend('fetch post')
                _dstart('load post')
                res.data.data.theme = fixTheme(res.data.data.theme)

                $timeout(() => {
                    // Try to decode config (base64)
                    let config = {}
                    if (configParams) {
                        try {
                            config = JSON.parse(fromBinary(configParams))

                            if (config && config.theme) {
                                if (config.theme.fonts && (!config.theme.fonts.primary || !config.theme.fonts.secondary)) {
                                    delete config.theme.fonts
                                }
                                res.data.data.theme = Object.assign({}, res.data.data.theme, config.theme)
                            }
                            if (typeof res.data.data.theme.fonts == 'undefined') {
                                logError({
                                    message: 'Error loading fonts',
                                })
                                res.data.data.theme = fixTheme(res.data.data.theme)
                            }
                            try {
                                if (config && config.global) {
                                    if (!res.data.data.global) {
                                        res.data.data.global = {}
                                    }
                                    res.data.data.global = Object.assign(res.data.data.global, config.global)
                                }
                            } catch (e) {
                                console.log('Error decoding global config', e)
                            }
                            if (!$scope.shouldSave()) {
                                return
                            }
                            api.savePost(id, res.data.data, type='user')
                            .then(function(res) {
                                $scope.notifyPostSaved()
                            })
                            .catch(function() {
                                // TASK - No handling
                            })
                            // Remove #hash from url
                            window.location.hash = ''
                            console.log('Updating post with new theme', config.theme)
                        } catch (e) {
                            console.log('Error decoding config', e)
                        }
                    }
                    $scope.loadPost(res.data)
                    _dend('load post')
                })
            }).catch(function(err) {
                let message = gettext('error.loading.post')
                if (err && err.status == 401) {
                    message = gettext('error.not_logged_in')
                }
                showError(message, null, function() {
                    if (IS_APP) {
                        changeURL('/')
                        return
                    }
                    if (window.origin.indexOf('localhost') != -1) {
                        window.location.href = window.origin + window.location.pathname.split('/').slice(0, -1).join('/') + '/auth'
                    } else {
                        window.location.href = window.origin + '/auth'
                    }
                })
            })
        } else {
            track('Editor Calendar View')
            // Load posts or generate initial content
            if (isLoggedIn()){
                $rootScope.$emit('loadPosts')
            } else {
                $rootScope.$emit('updatedUserInfo', true)
            }
            $scope.showFeatures()
        }

        if ($rootScope.mode == 'calendar') {
            $rootScope.tab = 'design'
        }

        $rootScope.$on('loadedPosts', function(event, posts) {
            if (posts == null) {
                $rootScope.$emit('updatedUserInfo', true)
            } else {
                $rootScope.$emit('updatedUserInfo', false)
            }
        })

        $rootScope.$on('editItem', function(event, data) {
            if (!$rootScope.isCalendar()) {
                return
            }

            // Remove settings
            if (data && data.theme && data.settings) {
                delete data.theme.settings
            }

            let isLoading = data.item && data.item.image && data.item.image.indexOf(LOADING_IMAGE) != -1
            if (isLoading) {
                showError(gettext('error.imageLoading'))
                return
            }

            if (data.item && data.item.serverId) {
                let postUrl = '?id=' + data.item.serverId
                if (IS_APP) {
                    postUrl += '&embed=true'
                }
                if ($rootScope.theme && !data.item.edited) {
                    try {
                        let updatedTheme = JSON.parse(JSON.stringify($rootScope.theme))
                        delete updatedTheme.settings
                        const base64String = toBinary(JSON.stringify({
                            theme: updatedTheme,
                            global: $rootScope.global,
                        }))
                        postUrl += '#config=' + base64String
                    } catch (e) {
                        console.log('Error encoding config', e)
                    }
                }
                if (IS_APP) {
                    $rootScope.$emit('openEditModal', {url: postUrl})
                } else {
                    window.open(location.pathname + postUrl, '_blank')
                }
                return
            }
            data.source = 'user'
            api.getOrCreatePost(data).then(function(res) {
                $rootScope.$broadcast('itemChanged', {
                    id: data.item.id,
                    changes: {
                        serverId: res.data._id
                    }
                })
                let postUrl = '?id=' + res.data._id
                if (IS_APP) {
                    postUrl += '&embed=true'
                }

                if (IS_APP) {
                    $rootScope.$emit('openEditModal', {url: postUrl})
                } else {
                    window.open(location.pathname + postUrl, '_blank')
                }
            })
            .catch(function() {
                // TASK - No handling
            })
        })

        $rootScope.$on('themeChanged', function(event, data) {
            $rootScope.theme = data
        })

        $rootScope.$on('postData', function(event, data) {
            if (data.post) {
                data.post.caption = $rootScope.caption
            }
            if (data.input.type == 'generateInitialContent') {
                if (data?.post?.items?.length > 1) {
                    showConfirm(gettext('label.content_already_generated'), null, function(status) {
                        if (status) {
                            let newText = convertItemsIntoText(data.post.items.slice(0, 1))
                            setEditorText(newText)
                            $timeout(function() {
                                $scope.render()
                                $scope.generateInitialContent($scope.post, force=true)
                            })

                        }
                    })
                } else {
                    $scope.generateInitialContent($scope.post, force=true)
                }
            }
            else if (data.input.type == 'download') {
                if (!$rootScope.postId) {
                    showError(gettext('error.saving.post'))
                    return
                }
                $scope.showDownload(data)
            } else if (data.input.type == 'preview') {
                if (!$rootScope.postId) {
                    showError(gettext('error.saving.post'))
                    return
                }
                $scope.showPreview(data)
            }
            else if (data.input.type == 'save') {
                if (!$rootScope.postId) {
                    showError(gettext('error.saving.post'))
                    return
                }
                let postId = $rootScope.postId
                if (!$scope.shouldSave()) {
                    return
                }
                api.savePost(postId, data.post).then(function(res) {
                    showSuccess(gettext('success.saving.post'))
                    $scope.notifyPostSaved()
                }).catch(function(err) {
                    console.log(err)
                    showError(gettext('error.saving.post'))
                })
            } else if (data.input.type == 'sync') {
                if (!$rootScope.postId) {
                    return
                }
                let postId = $rootScope.postId
                if (!$scope.shouldSave()) {
                    return
                }
                api.savePost(postId, data.post)
                .then(function(res) {
                    $scope.notifyPostSaved()
                })
                .catch(function() {
                    // TASK - No handling
                })
            } else if (data.input.type == 'bulkedit') {
                if (!$rootScope.postId) {
                    return
                }
                window.postMessage({
                    name: 'postUpdated',
                    id: $rootScope.postId,
                    post: data.post,
                }, '*')
            }
        })

        $rootScope.$on('captionUpdated', function(event, data) {
            if (!$rootScope.isEditor()) {
                return
            }
            if (!$rootScope.postId) {
                return
            }
            if (!$scope.shouldSave()) {
                return
            }
            api.savePost($rootScope.postId, data)
            .then(function(res) {
                $scope.notifyPostSaved()
            })
            .catch(function() {
                // TASK - No handling
            })
            $scope.post.data.caption = data.caption
        })

        $rootScope.$on('contentModified', function(event, data) {
            if (!$rootScope.postId) {
                return
            }
            $scope.post.data.format = data.post.format
            $scope.post.data.mediaFormat = data.post.mediaFormat

            let postId = $rootScope.postId
            if (!$scope.shouldSave()) {
                return
            }
            api.savePost(postId, data.post)
            .then(function(res) {
                $scope.notifyPostSaved()
            })
            .catch(function() {
                // TASK - No handling
            })

            $rootScope.notifyPostUpdated()
        })

        $rootScope.$on('onItemCreated', function(event, data) {
            if (!$scope.view.state.generatingContent) {
                return
            }

            let index = data.length - 1
            if (index < 1) {
                return
            }
            let lastItem = JSON.parse(JSON.stringify(data[index]))

            $rootScope.$broadcast('itemChanged', {
                id: index,
                changes: {
                    image: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif?20151024034921'
                }
            })
            let mergedTitle = lastItem.title.stripHtml().trim()
            if (mergedTitle.match(/^[0-9]+\./)) {
                mergedTitle = mergedTitle.replace(/^[0-9]+\./, '').trim()
            }
            if (SHOULD_MERGE_TITLE_IMAGES) {
                lastItem.title = `${mergedTitle} [${data[0].title}]`
            } else {
                lastItem.title = `${mergedTitle}`
            }

            if (!lastItem.settings) {
                lastItem.settings = {}
            }
            if ($scope.post && $scope.post.meta && $scope.post.meta.project) {
                lastItem.project = $scope.post.meta.project
            }
            lastItem.settings.dynamic = {
                image: true
            }
            api.generateDynamic(lastItem).then(function(response) {
                let data = response.data
                console.log('Dynamic image generated', data)
                $timeout(() => {
                    $rootScope.$broadcast('itemChanged', {
                        id: index,
                        changes: {
                            image: data.image.url
                        }
                    })
                })
            })
        })

        let coupon = new URLSearchParams(window.location.search).get('cupom')
        if (coupon) {
            localStorage.setItem('galilai.coupon', coupon)
        }
    }

    $scope.setupModals = function() {
        // TODO - Fix jQuery
        publishModal = angular.element('#publish-modal')
        trialModal = angular.element('#trial-modal')
        plansModal = angular.element('#plans-modal')
        updatePaymentModal = angular.element('#update-payment-modal')
    }

    $scope.showConfig = function() {
        showSuccess(gettext('info.config.show'))
        track('Editor Layout View', {
            postId: $rootScope.postId
        })
    }

    $scope.showPublish = function(type, source) {
        if (!$rootScope.isProCustomer() && type == 'publish') {
            $rootScope.showUpgrade('Publish Post Directly')
            return
        }
        publishModal.modal('show')
        if (!$scope.post || !$scope.post.data) {
            return
        }
        let caption = null
        if ($scope.post.data.caption) {
            caption = $scope.post.data.caption
        }

        getEditor(function(editor) {
            $rootScope.$broadcast('publishContent', {
                caption: caption,
                text: editor.getText(),
                post: $scope.post,
                type: type,
                source: source,
            })
        })

        // On hide broadcast publishContent
        publishModal.on('hidden.bs.modal', function (e) {
            $rootScope.$broadcast('publishHidden')
        })

        track('Editor Publish View', {
            postId: $rootScope.postId
        })
    }

    $scope.init = function() {
        $scope.setupModals()
        $scope.initModes()
    }

    let debounceChangeText = null
    window.addEventListener('textChanged', function (e) {
        if (debounceChangeText) {
            $timeout.cancel(debounceChangeText)
        }
        debounceChangeText = $timeout(function() {
            $scope.parseText(e.detail.text);
        }, 300)
    });

    let notifyDebounceTimeout = null

    $rootScope.notifyPostUpdated = function() {
        if (notifyDebounceTimeout) {
            $timeout.cancel(notifyDebounceTimeout)
        }
        notifyDebounceTimeout = $timeout(function() {
            window.postMessage({
                name: 'postUpdated',
                id: $rootScope.postId,
            }, '*')
        }, 1000)
    }

    $scope.notifyPostSaved = function() {
        $scope.view.lastPostSaved = new Date()
    }

    $scope.doAction = function(action) {
        if (action == 'publish') {
            $scope.showPublish('publish')
        } else if (action == 'captions') {
            $scope.showPublish('captions')
        } else if (action == 'save') {
            $scope.saveAll()
        } else if (action == 'download') {
            $rootScope.tab = 'editor'
            $scope.downloadAll()
        } else if (action == 'config') {
            $scope.showConfig()
        } else if (action == 'preview') {
            $scope.previewPost()
        }
    }
})

angular.module('galilai.creator').controller('ContentTypeController', function($scope, $rootScope) {
    $scope.view = {
        contentTypes: [
            {
                label: gettext('label.post_type_carousel'),
                value: 'carousel',
                multiple: true,
                icon: 'mdi-view-carousel',
            },
            {
                label: 'Reels',
                value: 'reels',
                multiple: true,
                icon: 'mdi-video-vintage',
            },
            {
                label: gettext('label.post_type_single'),
                value: 'post',
                multiple: false,
                icon: 'mdi-image',
            },
            {
                label: 'Story',
                description: gettext('label.one_page'),
                value: 'story',
                multiple: false,
                icon: 'mdi-crop-portrait',
            },
            {
                label: 'Story',
                description: gettext('label.multiple_pages'),
                value: 'story',
                multiple: true,
                icon: 'mdi-crop-portrait',
            },
        ]
    }
    $scope.selectType = function(selection, $event) {
        $event.stopPropagation()
        $rootScope.$broadcast('contentTypeChanged', selection)
    }
})